export default __webpack_public_path__ + "static/media/icon-tutorial-01.88d802e1.svg";